import { Grid, Typography, Box, Paper, Button } from "@mui/material";

const No_Payment_History = ({ isSearchActive = false }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        position: "relative",
        background: "#FFFFFF",
        borderRadius: 4,
        p: { xs: 4, md: 8 },
        maxWidth: 900,
        mx: "auto",
        minHeight: 400,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Decorative Circles */}
      <Box
        sx={{
          position: "absolute",
          top: -50,
          right: -50,
          width: 120,
          height: 120,
          borderRadius: "50%",
          backgroundColor: "#9D03850F",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -50,
          left: -50,
          width: 160,
          height: 160,
          borderRadius: "50%",
          backgroundColor: "#9D03850F",
        }}
      />

      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ zIndex: 2 }}
      >
        {/* Heart Icon */}
        <Grid item>
          <svg
            width="94"
            height="94"
            viewBox="0 0 94 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="47" cy="47" r="47" fill="#9D0385" fillOpacity="0.06" />
            <path
              d="M46.9974 62.3333C45.4641 61.1194 43.803 60.177 42.0141 59.5062C40.2252 58.8353 38.3724 58.4999 36.4557 58.4999C35.1141 58.4999 33.7964 58.6756 32.5026 59.027C31.2089 59.3784 29.971 59.8735 28.7891 60.5124C28.1182 60.8638 27.4714 60.8478 26.8484 60.4645C26.2255 60.0812 25.9141 59.5221 25.9141 58.7874V35.6916C25.9141 35.3402 26.0019 35.0048 26.1776 34.6853C26.3533 34.3659 26.6168 34.1263 26.9682 33.9666C28.4377 33.1999 29.971 32.6249 31.5682 32.2416C33.1655 31.8583 34.7946 31.6666 36.4557 31.6666C38.3085 31.6666 40.1214 31.9062 41.8943 32.3853C43.6672 32.8645 45.3682 33.5833 46.9974 34.5416V57.7332C48.6266 56.711 50.3356 55.9444 52.1245 55.4333C53.9134 54.9221 55.7182 54.6666 57.5391 54.6666C58.6891 54.6666 59.8151 54.7624 60.9172 54.9541C62.0193 55.1458 63.1293 55.4333 64.2474 55.8166V32.8166C64.7266 32.9763 65.1978 33.144 65.6609 33.3197C66.1241 33.4954 66.5793 33.711 67.0266 33.9666C67.378 34.1263 67.6415 34.3659 67.8172 34.6853C67.9929 35.0048 68.0807 35.3402 68.0807 35.6916V58.7874C68.0807 59.5221 67.7693 60.0812 67.1464 60.4645C66.5234 60.8478 65.8766 60.8638 65.2057 60.5124C64.0238 59.8735 62.7859 59.3784 61.4922 59.027C60.1984 58.6756 58.8807 58.4999 57.5391 58.4999C55.6224 58.4999 53.7696 58.8353 51.9807 59.5062C50.1918 60.177 48.5307 61.1194 46.9974 62.3333ZM50.8307 52.7499V34.5416L60.4141 24.9583V44.1249L50.8307 52.7499ZM43.1641 55.8645V36.8895C42.1099 36.4423 41.0158 36.0989 39.8818 35.8593C38.7477 35.6197 37.6057 35.4999 36.4557 35.4999C35.2738 35.4999 34.1238 35.6117 33.0057 35.8353C31.8877 36.0589 30.8016 36.3944 29.7474 36.8416V55.8645C30.8655 55.4492 31.9755 55.1458 33.0776 54.9541C34.1797 54.7624 35.3057 54.6666 36.4557 54.6666C37.6057 54.6666 38.7318 54.7624 39.8339 54.9541C40.9359 55.1458 42.046 55.4492 43.1641 55.8645Z"
              fill="#9D0385"
            />
          </svg>
        </Grid>

        {/* Heading */}
        <Grid item>
          <Typography
            align="center"
            sx={{
              fontFamily: "Inters, sans-serif",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "100%",
              color: "#9D0385",
            }}
          >
            {isSearchActive ? "No Results Found" : "No Payment History"}
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item>
          <Typography
            align="center"
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "140%",
              color: "#555555",
              maxWidth: 750,
              mx: "auto",
            }}
          >
            {isSearchActive
              ? "No results found for your search. Try using a different keyword or clear the search filter."
              : "You haven't made any payments or enrolled in any programs yet. Once you enroll in a program and make payments, your payment history will appear here."}
          </Typography>
        </Grid>

        {/* Button */}

        <Grid item pb={10}>
          <Button
            variant="contained"
            href="/sap/pricing-plan"
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontWeight: 600,
              backgroundColor: "#9D0385",
              "&:hover": { backgroundColor: "#9D0385" },
            }}
          >
            Explore Packages
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default No_Payment_History;
